<template>
  <div>
    <!-- <Header /> -->
    <div v-if="userInfo && userInfo.user">
      <AdminHeader v-if="this.userInfo.user.permission == 'super_admin'" />
      <HodHeader v-if="this.userInfo.user.permission == 'hod'" />
      <CoordinateHeader
        v-if="this.userInfo.user.permission == 'co-ordinator'"
      />
      <InstructorHeader v-if="this.userInfo.user.permission == 'instructor'" />
    </div>
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <div class="py-10 max-h-screen overflow-y-auto">
      <div class="container mx-auto max-w-[1200px] flex flex-col gap-10 px-6">
        <div>
          <h1
            class="text-xl md:text-xl text-start font-bold text-black"
            v-if="blogcount"
          >
            Blogs ({{ blogcount || 0 }})
          </h1>
        </div>

        <!-- Loading -->
        <div
          v-if="loading"
          class="flex items-center justify-center min-h-[300px] md:min-h-[400px]"
        >
          <img src="@/assets/newd/loading.gif" alt="Loading..." />
        </div>

        <!-- Blog List -->
        <div v-else-if="this.bloglist.length > 0">
          <div
            class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-10"
          >
            <div
              class="rounded-3xl bg-white shadow-lg relative"
              v-for="blog in this.bloglist"
              :key="blog.id"
            >
              <router-link
                :to="{
                  name: 'InstructorBlogDetails',
                  params: { blog_id: blog.id },
                }"
              >
                <div
                  class="flex flex-col min-h-[380px] md:min-h-[420px] justify-between gap-3 p-6"
                >
                  <!-- Thumbnail -->
                  <img
                    v-if="blog.thumbnail"
                    class="object-cover object-center h-[200px] md:h-[250px] w-full rounded-lg"
                    :src="blog.thumbnail"
                    alt="Blog Thumbnail"
                  />
                  <img
                    v-else
                    class="object-cover object-center h-[100px] md:h-[150px] w-auto rounded mx-auto"
                    src="@/assets/coding.svg"
                    alt="Default Image"
                  />

                  <!-- Edit Button -->
                  <router-link
                    :to="{
                      name: 'InstructorBlogsEdit',
                      params: { blog_id: blog.id },
                    }"
                    class="absolute top-6 right-12 text-sm px-3 py-1 text-white font-bold rounded-md"
                  >
                    <img
                      src="@/assets/new/medit.png"
                      alt=""
                      srcset=""
                      class="w-6 h-6 bg-[#EDF8FF] hover:bg-green-200 p-1"
                    />
                  </router-link>

                  <!-- Blog Details -->
                  <h1 class="font-bold text-lg text-primary leading-6">
                    {{ blog.title }}
                  </h1>
                  <p class="text-blues text-sm font-bold">
                    {{ blog.bolger_id.display_name }}
                  </p>

                  <div class="text-sm text-gray-500 font-medium">
                    {{ formatDate(blog.updated_date) }}
                  </div>

                  <p
                    class="text-black line-clamp-3 text-sm"
                    v-html="blog.content"
                  ></p>
                </div>
              </router-link>
              <!-- Delete Button -->
              <div
                class="absolute top-7 right-6 z-10 cursor-pointer"
                @click.stop="
                  titlepass = blog.title;
                  popupwindow = true;
                  idpass = blog.id;
                "
              >
                <img
                  src="@/assets/new/dele.png"
                  alt="Delete"
                  class="w-6 h-6 bg-red-100 hover:bg-red-200 p-1 rounded"
                />
              </div>
            </div>
          </div>

          <!-- Pagination Controls -->

          <div
            v-if="this.bloglist.length > 1"
            class="flex items-center justify-center w-full pb-8"
          >
            <Pagination :totalPages="totalPages" @page-changed="fetchBlogs" />
          </div>
        </div>

        <!-- No Data -->
        <div v-else class="text-lg font-normal text-center">No data found</div>
        <!-- delect popup -->

        <div
          v-if="popupwindow"
          class="fixed flex bg-black bg-opacity-70 justify-center items-center inset-0 z-50 outline-none overflow-x-hidden overflow-y-auto"
          style="z-index: 5000"
        >
          <div class="w-[90%] lg:w-[35%] rounded-md m-4">
            <div
              class="relative flex flex-col clear-both justify-center rounded-t-lg w-full pt-12 p-4 md:p-10 bg-white gap-3"
            >
              <img
                @click="popupwindow = false"
                class="absolute right-2 top-2 cursor-pointer"
                src="@/assets/newd/close.png"
              />
              <p class="text-center font-base text-xl text-gray-600">
                Are you sure want to delete ?
              </p>
              <h1 class="text-center font-bold text-xl text-teal-600">
                {{ titlepass }}
              </h1>
            </div>
            <div
              class="body-popup flex flex-col rounded-b-lg py-3 md:py-6 px-3 md:px-6 bg-gray-200"
            >
              <div class="flex gap-4 justify-between w-full md:w-3/4 mx-auto">
                <div class="flex gap-3 items-center">
                  <button
                    @click="deleteblog()"
                    :disabled="disable_submit == true"
                    :class="
                      this.disable_submit == true
                        ? 'bg-white text-black cursor-not-allowed'
                        : 'bg-teal-800 hover:bg-teal-600 cursor-pointer text-white border-greens'
                    "
                    class="text-sm font-semibold rounded overflow-hidden px-4 py-2 border"
                  >
                    Yes
                  </button>
                  <img
                    v-if="disable_submit"
                    src="@/assets/loading.gif"
                    alt="loading"
                    class="w-6 h-6 object-contain"
                  />
                </div>
                <button
                  @click="popupwindow = false"
                  class="bg-white hover:bg-gray-300 text-gray-700 text-sm font-semibold rounded overflow-hidden px-4 py-2"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InstructorHeader from "@/components/Instructor/Header.vue";
import AdminHeader from "@/components/Admin/Header.vue";
import HodHeader from "@/components/Hod/Header.vue";
import CoordinateHeader from "@/components/Coordinate/Header.vue";
import FlashMessage from "@/components/FlashMessage.vue";

import axios from "axios";
import { mapGetters } from "vuex";

import Pagination from "@/components/Pagination.vue";

export default {
  components: {
    InstructorHeader,
    AdminHeader,
    HodHeader,
    CoordinateHeader,
    FlashMessage,
    Pagination,
  },

  data() {
    return {
      bloglist: [],

      loading: true,
      popupwindow: false,
      titlepass: null,
      idpass: null,
      messages: {
        text: "",
        type: "null",
      },
      blogcount: null,
      totalPages: null,
      currentPage: 1,
      disable_submit: false,
    };
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },

  created() {
    this.fetchBlogs(1);
  },

  methods: {
    fetchBlogs(value) {
      this.currentPage = value;
      axios
        .get(
          `${process.env.VUE_APP_API}/blog-details/list/?page=${value}&Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          if (res.data.data.status == 200) {
            this.bloglist = res.data.data.data;
            this.blogcount = res.data.total;
            setTimeout(() => {
              this.loading = false;
            }, 1000);
            this.totalPages = res.data.total_page;
          }
        })
        .catch((error) => {
          console.error("Error fetching blogs:", error);
        });
    },

    formatDate(date) {
      return new Date(date).toLocaleDateString("en-IN", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
    async deleteblog() {
      this.disable_submit = true;
      await axios
        .delete(
          `${process.env.VUE_APP_API}/blog-details/deleted/${this.idpass}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            console.log("successful");
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            console.log("not successful");
          }
        });

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
        this.disable_submit = false;
        this.popupwindow = false;
        this.fetchBlogs(1);
      }, 2500);
    },
  },
};
</script>

<style></style>
